import { AFFILIATE_RECEIVE } from '../bevegoConstants';
export const affiliates = (
    state = {
        affiliates: [{ name: '', id: '', address: {}, selected: false }],
    },
    action
) => {
    switch (action.type) {
        case AFFILIATE_RECEIVE:
            return [...action.payload];
        default:
            return state;
    }
};
